export var BADGE_COLORS = {
  blue: 'blue',
  green: 'green',
  orange: 'orange',
  purple: 'purple',
  red: 'red',
  standard: 'darkGray',
  yellow: 'yellow'
};